import i18n from './../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../core/components/input-widget/BaseModel";
import {ALPHA_NUMERIC_REGEX} from "../../plugins/vee-validate";
import {store} from './../../plugins/vuex/index'

export default class BidderModel extends BaseModel {
  uuid = null;
  auction_uuid = null;
  customer_uuid = null;
  paddle_number = null;
  credit_limit = null;
  preferred_clerk_uuid = null;
  status = null;
  skip_auction_deposit_requirement = null;
  language_uuid = null;
  skip_credit_card_verification = null;
  skip_identity_verification = null;
  trust_level_uuid = null;
  pre_approve_commission_bids = false;
  pre_approve_telephone_bids = false;
  is_pickup = null;

  static TRANSLATABLE_FIELDS = [];

  rules = {
    auction_uuid: 'required',
    paddle_number: `required|regex:${ALPHA_NUMERIC_REGEX}|max:10`,
  };

  attributeLabels = {
    auction_uuid: i18n.t('Sale'),
    customer_uuid: i18n.t('Customer'),
    paddle_number: i18n.t('Paddle Number'),
    credit_limit: i18n.t('Bidding Limit'),
    status: i18n.t('Approval Status'),
    skip_auction_deposit_requirement: i18n.t('Exempt from Deposit'),
    skip_credit_card_verification: i18n.t('Exempt from Credit Card Verification'),
    skip_identity_verification: i18n.t('Exempt from Identity Verification'),
    language_uuid: i18n.t('Language'),
    preferred_clerk_uuid: i18n.t('Preferred Clerk'),
    pre_approve_commission_bids: i18n.t('Pre Approve Commission Bids'),
    pre_approve_telephone_bids: i18n.t('Pre Approve Telephone Bids'),
    is_pickup: i18n.t('Being Collected'),
  };

  attributeHints = {
    credit_limit: i18n.t('Please Enter the Bidding Limit'),
    trust_level_uuid: i18n.t('Please Enter Trust Level Tier'),
    status: i18n.t('If you leave this blank it will be automatically generated')
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});

    if (!this.status && Object.keys(data).length) {
      this.status = data.auction.show_bidder_approval_status ? store.state.global.defaultBidderStatus : 'approved';
    }

    this.initTranslatableFields(this);
  }
}

defineTranslatableProperties(BidderModel);
